import React from "react";
import { Link } from "gatsby";
import { Container, Row } from "react-bootstrap";

const BreadCrumb = ({ items }) => {
  return (
    <Container fluid>
      <Row>
        <nav aria-label="breadcrumb" className="custom-breadcrumb">
          <ol className="breadcrumb">
            {items.map((item, index) => (
              <li
                key={index}
                aria-current={index === items.length - 1 ? "page" : null}
                className={`breadcrumb-item${
                  index === items.length - 1 ? " active" : ""
                }`}
              >
                {index === items.length - 1 ? (
                  item.text
                ) : (
                  <Link to={item.link}>{item.text}</Link>
                )}
              </li>
            ))}
          </ol>
        </nav>
      </Row>
    </Container>
  );
};

export default BreadCrumb;
